import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Navigate, Route, Routes } from 'react-router-dom';

import AppTabs from '../../../components/designe/app-tabs/AppTabs';
import { useAccess } from '../../../hooks/useAccess';
import { Paths } from '../../../shared/paths';
import ExerciseProperties from '../exercise-properties/ExerciseProperties';
import ExerciseOptions from '../exercise-options/ExerciseOptions';
import ExerciseLoadFormulas from '../exercise-load-formulas/ExerciseLoadFormulas';

export function ExerciseManagementInnerTabs() {
  const { t } = useTranslation();
  const { access } = useAccess();
  const base = `${Paths.adminDashboard.root}${Paths.adminDashboard.exerciseManagement}`;
  const canViewExerciseProperties =
    access?.exerciseProperties?.canView ?? false;
  const canViewExerciseOptions = access?.exerciseOptions?.canView ?? false;
  const canViewExerciseLoadFormulas =
    access?.exerciseLoadFormulas?.canView ?? false;

  const tabsConfig = useMemo(() => {
    const tabs = [];

    if (canViewExerciseProperties) {
      tabs.push({
        label: t('adminDashboard.exerciseProperties'),
        path: `${base}/properties`,
      });
    }

    if (canViewExerciseOptions) {
      tabs.push({
        label: t('adminDashboard.exerciseOptions'),
        path: `${base}/options`,
      });
    }

    if (canViewExerciseLoadFormulas) {
      tabs.push({
        label: t('adminDashboard.exerciseLoadFormulas'),
        path: `${base}/load-formulas`,
      });
    }

    return tabs;
  }, [
    base,
    canViewExerciseLoadFormulas,
    canViewExerciseOptions,
    canViewExerciseProperties,
    t,
  ]);

  const defaultTab =
    tabsConfig[0]?.path?.replace(`${base}/`, '')?.replace(/^\/+/, '') || '';

  return (
    <>
      <AppTabs config={tabsConfig} />
      <Box sx={{ mt: 2 }}>
        <Routes>
          {canViewExerciseProperties && (
            <Route path="properties" element={<ExerciseProperties />} />
          )}
          {canViewExerciseOptions && (
            <Route path="options" element={<ExerciseOptions />} />
          )}
          {canViewExerciseLoadFormulas && (
            <Route path="load-formulas" element={<ExerciseLoadFormulas />} />
          )}
          <Route
            index
            element={<Navigate to={defaultTab || Paths.root} replace />}
          />
        </Routes>
      </Box>
    </>
  );
}
